import React from "react";

import "./Wrapper.scss";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function Wrapper({ children, className, ...props }: IProps) {
    const classNames = ["userful-wrapper", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
